export default __webpack_public_path__ + "fonts/inspiretwdc-mediumitalic.woff2";